import EVImg from '@components/EVImg';
import Block from '@components/Layout/Block';
import {
  CarouselNavButtonLeft,
  CarouselNavButtonRight,
} from '@components/MiscComponents/GridAndCarouselComponents/index';
import { VerticalLineSeparator } from '@components/MiscComponents/VerticalLineSeparator';
import RichText from '@components/RichText';
import { Document } from '@contentful/rich-text-types';

import Link from 'next/link';
import { FC } from 'react';
import { A11y, Navigation } from 'swiper';
import { Swiper } from 'swiper/react';
import {
  Body,
  ButtonContainer,
  Heading,
  SliderContainer,
  StyledSwiperSlide,
  TopContainer,
} from './styles';

export interface FlexCollarProps {
  header: string;
  bodyText: string | Document;
  flexCollarSlides: {
    header?: string;
    img?: string;
    url?: string;
  }[];
}

const FlexCollar: FC<FlexCollarProps> = ({
  header = 'Flex Collar',
  bodyText,
  flexCollarSlides,
}) => {
  return (
    <Block>
      <TopContainer>
        <Heading data-testid="flex-collar-header">{header}</Heading>

        <VerticalLineSeparator />

        <Body data-testid="flex-collar-description">
          {bodyText &&
            (typeof bodyText === 'string' ? (
              <p>{bodyText as string}</p>
            ) : (
              <RichText richText={bodyText as Document} />
            ))}
        </Body>
      </TopContainer>
      {flexCollarSlides && (
        <SliderContainer data-testid="flex-collar-slider-container">
          <Swiper
            modules={[Navigation, A11y]}
            slidesPerView={2}
            spaceBetween={16}
            centerInsufficientSlides={true}
            data-testid="flex-collar-swiper"
            navigation={{
              prevEl: '.flexcollar-prev',
              nextEl: '.flexcollar-next',
            }}
            a11y={{
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
            }}
            breakpoints={{
              535: {
                slidesPerView: 3,
              },
              900: {
                slidesPerView: 4,
              },
              1156: {
                slidesPerView: 5,
              },
              1330: {
                slidesPerView: 6,
              },
            }}
          >
            {flexCollarSlides.map((s) => {
              //ShopGroup and Shop pages will link to the lifestyles of the America's shop
              const isExternal = s.url && s.url.includes('www.evrealestate.com');

              return (
                <StyledSwiperSlide key={s.header} data-testid={s.header}>
                  {s.url ? (
                    <Link href={s.url} target={isExternal ? '_blank' : '_self'}>
                      <EVImg src={s.img} sizes={'200px'} priority={true} />
                      <span>{s.header}</span>
                    </Link>
                  ) : (
                    <>
                      <EVImg src={s.img} sizes={'200px'} priority={true} />
                      <span>{s.header}</span>
                    </>
                  )}
                </StyledSwiperSlide>
              );
            })}
            <ButtonContainer>
              <CarouselNavButtonLeft className="flexcollar-prev" />
              <CarouselNavButtonRight className="flexcollar-next" />
            </ButtonContainer>
          </Swiper>
        </SliderContainer>
      )}
    </Block>
  );
};

export default FlexCollar;
